export default __webpack_public_path__ + "static/media/power-button.8411216a.png";